App.controller('CompleteRegistrationCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', '$stateParams', 'authService', 'statesService', 'branchService', '$filter', 'popUpService', function ($scope, $sce, $state, $http, $mdDialog, Config, $stateParams, authService, statesService, branchService, $filter, popUpService) {
    $scope.stateParams = $stateParams;
    $scope.token = $scope.stateParams.token;

    $scope.data = {
        login: '',
        password: '',
        person: {}
    }

    authService.zochaRegistrationDataByToken($scope.token).then(function (data) {
        if (data.status === 200) {
            $scope.data.login = data.data.email;
            $scope.data.person.phone = data.data.phone;

            if (data.data.branch) {
                $scope.selectedBranch = data.data.branch;
            }
        } else {
            if (data.data.message === 'TokenExpiredException') {
                $scope.tokenExpired = true;
                popUpService.showPopUpWithError(data.data, {ev: '', head: 'Błąd!', content: 'Konto zostało już zarejestrowane lub token jest nieprawidłowy, w razie pytań skontaktuj się z administratorem.', text: 'Zaloguj się', target: 'root.login'});
            }
            $scope.data.login = '';
        }
    });

    $scope.data.agreements = [{
            id: 0,
            content: '<span>Zawieram umowę o świadczenie usług drogą elektroniczną poprzez założenie konta użytkownika. <br/> Zostałem poinformowany/poinformowana, że w każdej chwili mogę wypowiedzieć umowę o świadczenie usług drogą elektroniczną bez wskazywania przyczyny. Wypowiedzenie przeze mnie umowy oznacza zakończenie możliwości korzystania z Portalu i produktów/usług oferowanych za pośrednictwem Portalu.</span>&nbsp;<span class="required">*</span>',
            accepted: false
        },
        {
            id: 1,
            content: '<span>Zapoznałem/zapoznałam się z <a ui-sref="root.regulations" title="" target="_blank">Regulaminem świadczenia usług drogą elektroniczną</a> i <a ui-sref="root.privacypolicy" title="" target="_blank">Polityką prywatności</a>.</span></span>&nbsp;<span class="required">*</span>',
            accepted: false
        },
        {
            id: 2,
            content: '<span>Zapoznałem/zapoznałam się z <a href="" ng-click="showInformationObligation()">treścią obowiązku informacyjnego</a>.</span></span>&nbsp;<span class="required">*</span>',
            accepted: false
        }
    ];

    $scope.data.consents = [
        {
            id: 0,
            content: '<label>1. W celu w celu oferowania Ci przez nas produktów i usług bezpośrednio, w tym dobierania ich pod kątem Twoich potrzeb z pomocą profilowania?</label>',
            accepted: null
        },
        {
            id: 1,
            content: '<label>2. W celu oferowania Ci bezpośrednio (marketing bezpośredni) produktów i usług firm z nami współpracujących (naszych partnerów), w tym dobierania ich pod kątem Twoich potrzeb z pomocą profilowania?</label>',
            accepted: null
        },
        {
            id: 2,
            content: '<label>3. Na przekazywanie przez nas treści, dotyczących naszej oferty na podany numer telefonu (w tym przy użyciu automatycznych systemów wywołujących w rozumieniu ustawy z dnia 16 lipca 2004 r. Prawo telekomunikacyjne)?</label>',
            accepted: null
        },
        {
            id: 3,
            content: '<label>4. Na przetwarzanie swoich danych osobowych przez podmioty współpracujące z nami w celu marketingu bezpośredniego dotyczącego produktów i usług oferowanych przez te podmioty (wykonywanego przy użyciu telekomunikacyjnych urządzeń końcowych oraz automatycznych systemów wywołujących , zgodnie z art. 172 ustawy z dnia 16 lipca 2004r. Prawo telekomunikacyjne)?</label>',
            accepted: null
        }
    ]

    $scope.$watch('data.password', function() {
        if (!$scope.data.password) {
            $scope.strongPassword = 0;
            return 0;
        } else {
            $scope.strongPassword = $scope.data.password.length * 10/2;

            if ($scope.strongPassword <= 40) {
                $scope.strongPasswordLabel = 'Słabe';
            } else if ($scope.strongPassword <= 60) {
                $scope.strongPasswordLabel = 'Średnie';
            } else if ($scope.strongPassword <= 80) {
                $scope.strongPasswordLabel = 'Dobre';
            } else {
                $scope.strongPasswordLabel = 'Znakomite';
            }
        }
    });

    $scope.confirmIdentifier = function() {
        var criteria = {
            token: $scope.token,
            data: {
                identifier: $scope.identifier
            }
        }
        authService.checkIdentifierForZochaRegistrationToken(criteria).then(function (data) {
            if (data.status === 200) {
                $scope.showForm = true;
            } else {
                popUpService.showPopUpWithError(data, {ev: '', head: 'Nieprawidłowy PESEL/Numer paszportu', content: 'Podany PESEL/Numer paszportu jest nieprawidłowy, spróbuj ponownie.', text: 'Ok', target: ''});
            }
        });
    }

    $scope.completeRegister = function() {
        var vm = this;

        if ($scope.tokenExpired) {
            $scope.showPopUp('', 'Błąd!', 'Konto zostało już zarejestrowane lub token jest nieprawidłowy, w razie pytań skontaktuj się z administratorem.', 'Zaloguj się', 'root.login');
            document.body.scrollTop = document.documentElement.scrollTop = 80;
            return 0;
        }

        if (!vm.form.$valid) {
            $scope.showPopUp('', 'Uzupełnij pola', 'Aby dokończyć rejestrację wypełnij wszystkie wymagane pola.', '');
            document.body.scrollTop = document.documentElement.scrollTop = 80;
            return 0;
        }

        if ($scope.data.password !== $scope.password_repeat) {
            $scope.showPopUp('', 'Niezgodne hasła', 'Podane hasła nie są do siebie podobne.', '');
            return 0;
        }

        if (!$scope.data.agreements[0].accepted
        || !$scope.data.agreements[1].accepted
        || !$scope.data.agreements[2].accepted) {
            $scope.showPopUp('', 'Zaakceptuj oświadczenia', 'Aby dokończyć rejestrację zaakceptuj wymagane oświadczenia.');
            return 0;
        }

        if ($scope.data.consents[0].accepted === null
        || $scope.data.consents[1].accepted === null
        || $scope.data.consents[2].accepted === null
        || $scope.data.consents[3].accepted === null) {
            $scope.showPopUp('', 'Dokonaj wyboru przy zgodach', 'Aby dokończyć rejestrację zaznacz Tak lub Nie przy zgodach.');
            return 0;
        }

        $scope.data.person.identifier = $scope.identifier;
        $scope.data.person.branch = $scope.selectedBranch.name;
        $scope.data.person.branchId = $scope.selectedBranch.id;

        var criteria = {
            token: $scope.token,
            data: {
                identifier: $scope.identifier
            }
        }
        authService.checkIdentifierForZochaRegistrationToken(criteria).then(function (data) {
            if (data.status === 200) {
                completeRegister();
            } else {
                $scope.showPopUp('', 'Nieprawidłowy PESEL/Numer paszportu', 'Podany PESEL/Numer paszportu jest nieprawidłowy, spróbuj ponownie.', 'Ok', '');
            }
        });
    }

    function completeRegister() {
        authService.completeRegister($scope.token, $scope.data).then(function (data) {
            if (data.status === 200) {
                $scope.showPopUp('', 'Gratulacje!', 'Może zalogować się do systemu.', 'Zaloguj się', 'root.login');
            } else {
                if (data.data.message === 'DuplicateIdentifierException') {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Rejestracja nieudana', content: 'Podany PESEL/Numer paszportu został juz zarejestrowany w bazie.', text: '', target: ''});
                } else if (data.data.message === 'DuplicateLoginException') {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Rejestracja nieudana', content: 'Podany login jest już zajęty, użyj innego.', text: '', target: ''});
                } else if (data.data.message === 'DuplicateEmailException') {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Rejestracja nieudana', content: 'Podany adres e-mail jest już zajęty, użyj innego.', text: '', target: ''});
                } else {
                    popUpService.showPopUpWithError(data.data, {head: 'Rejestracja nieudana', content: 'Niestety nie udało się zarejestrować konta, skontaktuj się z administratorem.'});
                }
            }
        });
    }

    $scope.showInformationObligation = function() {
        $scope.showPopUpInformationObligation('');
    }

    $scope.showPopUp = function(ev, head, content, text, target) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function(data) {

        }, function() {

        });
    }

    $scope.showPopUpInformationObligation = function(ev) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-obligation.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {

            }
        }).then(function(data) {

        }, function() {

        });
    }

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide($scope.locals);
        };
    }
    PopUpInfoCtrl.$inject = ['$scope', '$mdDialog', 'locals'];

    branchService.dataBranchLists().then(function (data) {
        $scope.branch = $filter('hideBranchCargo')(data.data.data);
    });

    // ##### FILTER ##### //
    $scope.querySearchBranch = function(query) {
        var results = query ? $scope.branch.filter(createFilterForItem(query)) : $scope.branch;
        return results;
    };

    function createFilterForItem(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(items) {
            return (angular.lowercase(items.name).indexOf(lowercaseQuery) !== -1);
        };
    };

    $scope.$watch('data.email', function (oldVal, newVal) {
        if (oldVal !== newVal) {
            $scope.data.login = $scope.data.email;
        }
    });
}]);
